// @ts-strict-ignore
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { Component, HostListener, Inject } from '@angular/core';
import { DEFAULT_LANGUAGE } from './app.constants';
import { injectSetPageTitle } from './functions/inject-functions/inject-set-page-title';
import { KeyboardEventKey } from './model/enums/keyboard-event-keys';
import { Language } from './model/enums/language';
import { TooltipService } from './modules/shared/components/tooltip/tooltip.service';
import { ActiveMainComponentInfoService } from './services/active-main-component-info.service';
import { LanguageService } from './services/language.service';
import { WINDOW } from './services/window.service';

//Register modules for ag-grid
ModuleRegistry.registerModules([ClientSideRowModelModule, ClipboardModule]);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  @HostListener('window:beforeunload', ['$event']) promptUser(event: BeforeUnloadEvent) {
    if (this._activeComponentInfo.warnOnClose) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  lang: Language = DEFAULT_LANGUAGE;

  get displayUserLang(): Language {
    return this._languageService.getDisplayLanguageCode(this.lang);
  }

  constructor(
    private _activeComponentInfo: ActiveMainComponentInfoService,
    private _languageService: LanguageService,
    private _tooltipService: TooltipService,
    @Inject(WINDOW) private _window: Window
  ) {
    injectSetPageTitle();

    const escapeKeyupCallback = (event: KeyboardEvent) => {
      if (event.key === KeyboardEventKey.Escape && this._tooltipService.isVisible) {
        event.stopPropagation();
        this._tooltipService.hide();
      }
    };
    this._window.addEventListener('keyup', escapeKeyupCallback, true);

    this._languageService.userLanguage.subscribe((language) => {
      this.lang = language;
    });
  }
}
